export { default } from './Slider';
export type { default as SliderProps } from './Slider.types';
